/** Human-readable session labels and stable display numbers. */

import { translateWithVars } from './i18n/translateWithVars';
import { isMissingDisplayValue } from './displayFallbacks';

export function generateWorkerSessionId() {
  return `session_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
}

/**
 * Assigns per-worker sequential display numbers (1, 2, 3…) by login time.
 */
export function assignSessionDisplayNumbers(sessions = []) {
  const counters = {};
  const chronological = [...sessions].sort(
    (a, b) => new Date(a.loginTime || 0) - new Date(b.loginTime || 0)
  );
  const numberByKey = new Map();

  chronological.forEach((session) => {
    const workerKey = String(session.workerId || '_');
    counters[workerKey] = (counters[workerKey] || 0) + 1;
    const mapKey = `${session.workerId || ''}|${session.loginTime || ''}|${session.id || ''}`;
    numberByKey.set(mapKey, counters[workerKey]);
  });

  return sessions.map((session) => {
    const mapKey = `${session.workerId || ''}|${session.loginTime || ''}|${session.id || ''}`;
    return {
      ...session,
      displayNumber: numberByKey.get(mapKey) || 1
    };
  });
}

export function formatSessionDisplayLabel(session, translate) {
  const n = session?.displayNumber || 1;
  if (typeof translate === 'function') {
    return translateWithVars(translate('workerSessionManager.sessionNumber'), { n });
  }
  return `Session ${n}`;
}

/** Compact table cell — number only (e.g. 1, 2, 3). */
export function formatSessionTableNumber(session) {
  const n = Number(session?.displayNumber);
  return Number.isFinite(n) && n > 0 ? String(n) : '1';
}

/** Normalise worker names for display (handles legacy English placeholders). */
export function resolveWorkerDisplayName(name, fallback = '—') {
  if (isMissingDisplayValue(name)) return fallback;
  return String(name).trim();
}
